export default {
  homeHeader: {
    lang:'CN',
    keyword:'请输入关键字',
    home : 'Home'
  },
  homeFooter:{
    p1:'咨询电话',
    p2:'举博微信公众号',
    p3:'举博微信小程序',
    p4:'举重博物馆 版权所有 粤ICP备2024184608号-5'
  },
  homeBody:{
    p1:'开馆时间',
    p2:'开始进馆',
    p3:'停止进馆',
    p4:'闭馆时间',
    p5:'除法定节假日外，周一闭馆，实行免费预约参观制度',
    p6:'参观预约',
    p7:'小程序预约',
    p8:'邮箱预约',
    p9:'个人或团队预约参观均需在微信小程序进行预约',
    p10:'参观指南',
    p11:'公交',
    p12:'现代广场站（357路、352路等）',
    p13:'地铁',
    p14:'2号线到东莞站，转公交到现代广场站',
    p15:'自驾',
    p16:'东莞市石龙镇人民广场',
    p17:'导览服务',
    p18:'语音导览',
    p19:'专职讲解员中文定时免费导览',
    p20:'专职讲解员收费导览',
    p21:'关于举重博物馆',
    p22:'举重博物馆是由国家体育总局举重摔跤柔道运动管理中心、中国举重协会和东莞市人民政府三方共建的我国唯一一座全面展示中国举重运动发展及辉煌成就的国家级专题博物馆，坐落于曾哺育出新中国第一个打破世界纪录的陈镜开、夺得第一枚奥运举重金牌的曾国强等一大批享誉世界举坛运动员的著名“举重之乡”——东莞石龙。',
    p23:'地理位置',
    p24:'位于东莞市石龙镇',
    p25:'建筑面积',
    p26:'场馆总建筑面积 14400余平方米',
    p27:'馆内藏品',
    p28:'余件',
    p29:'新闻中心',
    p30:'查看更多',
    p31:'举重新闻',
    p32:'通知公告',
    p33:'资讯动态',
  },
  otherPage:{
    p1:'首页',
    p2:'小程序预约',
    p3:'短信预约',
    p4:'邮箱预约',
    p5:'可预约',
    p6:'活动已结束',
    p7:'查看详情',
    p8:'需预约',
    p9:'查看详情',
    p10:'附件',
    p11:'分享到',
    p12:'上一篇',
    p13:'下一篇',
    p14:'无',
    p15:'全部',
    p16:'位置',
    p17:'类型',
    p18:'年代',
    p19:'详情介绍',
    p20:'返回',
    p21:'展览名称',
    p22:'展览时间',
    p23:'位置',
    p24:'展厅欣赏',
    p25:'票价',
    p26:'展期',
    p27:'展览介绍',
    p28:'图片欣赏',
    p29:'特展名称',
    p30:'姓名',
    p31:'请输入真实姓名',
    p32:'证件类型',
    p33:'请选择证件类型',
    p34:'身份证',
    p35:'港澳通行证',
    p36:'台湾通行证',
    p37:'护照',
    p38:'军官证',
    p39:'士兵证',
    p40:'证件号码',
    p41:'请输入证件号码',
    p42:'邮箱号码',
    p43:'请输入邮箱号码',
    p44:'验证码',
    p45:'请输入验证码',
    p46:'获取验证码',
    p47:'时间',
    p48:'选择日期',
    p49:'确定',
    p50:'举重博物馆门票预定成功，入场验证码已经由邮件形式发送到您刚才的电子邮箱，请携带您本人实名登记的有效证据，以便核对。',
  }
}



// WEBPACK FOOTER //
// ./src/i18n/zh.js